// Location: src/components/admin/schedule/SchedulePodInfo.tsx
// Purpose: Display pod and brand voice information for a schedule
// Scope: Shows pod name, brand voice emoji and title

import React from 'react';
import { Schedule } from '@/types/schedules';
import { Pod } from '@/types/pods';

interface SchedulePodInfoProps {
	schedule: Schedule;
	allPods: Pod[];
	brandVoice: string;
}

const BRAND_VOICE_TITLES = {
	prometheus: '🔥 Prometheus',
	reverend: '🎭 The Reverend',
	brent: '💼 Brent Ecomm Master',
	user: '✨ Custom Voice',
};

function getBrandVoiceEmoji(brandVoiceId: string) {
	switch (brandVoiceId) {
		case 'prometheus':
			return '🔥';
		case 'reverend':
			return '🎭';
		case 'brent':
			return '💼';
		case 'user':
			return '✨';
		default:
			return '🎯';
	}
}

export const SchedulePodInfo = React.memo(function SchedulePodInfo({
	schedule,
	allPods,
	brandVoice,
}: SchedulePodInfoProps) {
	return (
		<>
			<div className='flex flex-col gap-2'>
				{schedule.pod?.brandVoice && (
					<span className='px-2 py-1 rounded-full text-xs font-semibold bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-200 w-fit'>
						{getBrandVoiceEmoji(schedule.pod.brandVoice.id)}{' '}
						{schedule.pod.brandVoice.id.charAt(0).toUpperCase() +
							schedule.pod.brandVoice.id.slice(1)}{' '}
						Voice
					</span>
				)}
				<span className='text-xl text-gray-900 dark:text-white font-bold'>
					Pod:{' '}
					<span className='text-gray-900 dark:text-white text-2xl'>
						{allPods?.find((p) => p._id === schedule.targetId)
							?.name || 'Unknown Pod'}
					</span>
				</span>
			</div>

			<div className='flex items-center gap-2 mb-4'>
				<span className='text-lg font-semibold text-gray-900 dark:text-white'>
					Brand Voice:
				</span>
				<span className='text-lg font-bold text-pink-500 flex items-center gap-2'>
					{BRAND_VOICE_TITLES[
						brandVoice as keyof typeof BRAND_VOICE_TITLES
					] || `${getBrandVoiceEmoji(brandVoice)} ${brandVoice}`}
				</span>
			</div>
		</>
	);
});
